import { ApiHttpService } from '../ApiHttpService';
import { ParamsHelper } from '../../helpers/ParamsHelper';
import { CompareSerializer } from '../serializers/CompareSerializer';
import { Compare } from '../../models/Compare';

const VALIDATE_COMPARISON_PATH = 'Articulos/ValidarComparables';
const COMPARE_PATH = 'Articulos/Comparar';

class CompareController {
  static async validateComparison(products) {
    /*
      Doing it this way we can easily add more prducts
      to compare in the future
    */
    const productIds = products.map(product => product.id);
    const query = {};
    productIds.forEach((productId, index) => {
      query[`artID${index + 1}`] = productId;
    });
    const queryParams = ParamsHelper.createQueryParams(query);
    const response = await ApiHttpService.get(`${VALIDATE_COMPARISON_PATH}${queryParams}`);
    return response.data;
  }

  static async compare(products) {
    /*
      Doing it this way we can easily add more prducts
      to compare in the future
    */
    const query = {};
    products.forEach((productId, index) => {
      query[`artID${index + 1}`] = productId;
    });
    const queryParams = ParamsHelper.createQueryParams(query);
    const response = await ApiHttpService.get(`${COMPARE_PATH}${queryParams}`);
    const deSerializedData = response.data.map(CompareSerializer.deSerialize);
    return deSerializedData.map(data => new Compare(data));
  }
}

export { CompareController };



// WEBPACK FOOTER //
// ./src/networking/controllers/CompareController.js